"use strict";
exports.__esModule = true;
exports.chart_global_warning_Color_200 = {
  "name": "--pf-v5-chart-global--warning--Color--200",
  "value": "#f0ab00",
  "var": "var(--pf-v5-chart-global--warning--Color--200, #f0ab00)"
};
exports["default"] = exports.chart_global_warning_Color_200;